export class Country {
    id: string;
    name: string;
}